export default __webpack_public_path__ + "static/media/property_199.683cfe4d.png";